import React from 'react';
import { getToolMessage } from '../../utils/toolMessages';

interface LoadingIndicatorProps {
  currentStatus: string | undefined;
  currentTool: string | undefined;
  elapsedTime: number;
  t: any;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  currentStatus,
  currentTool,
  elapsedTime,
  t
}) => {
  const formatElapsedTime = (seconds: number) => {
    if (seconds < 60) {
      return `${seconds}s`;
    } else {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}m ${remainingSeconds}s`;
    }
  };

  return (
    <div className="flex justify-start">
      <div className="bg-white rounded-lg md:rounded-xl px-2.5 md:px-3 sm:px-4 py-2 md:py-2.5 sm:py-3 max-w-[92%] md:max-w-[88%] sm:max-w-[85%] shadow-md border border-gray-100">
        {currentStatus && (
          <div className="text-sm md:text-base text-gray-700 mb-1.5 md:mb-2 font-medium">{currentStatus}</div>
        )}
        {currentTool && (
          <div className="text-xs text-emerald-600 mb-1.5 md:mb-2 flex items-center space-x-1">
            <span>🔧</span>
            <span>{getToolMessage(currentTool, t)}</span>
          </div>
        )}
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
          <span className="text-xs md:text-sm text-gray-600">{t('chat.aiWorking')}</span>
          <span className="text-xs md:text-sm text-gray-600">{formatElapsedTime(elapsedTime)}</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;